import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "./util";

export const getProductList = ({
  setProducts = function () {
    return;
  },
  setShared = function () {
    return;
  },
  setWriteAccess = function () {
    return;
  },
  chosenYear,
  assessmentType = null, // Filter by assessment_type if provided
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    params: {
      year: year ? year : chosenYear,
      assessment_type: assessmentType || undefined, // Include assessment_type in params if provided
    },
  };

  axios(config)
    .then(function (response) {
      let filteredProducts = response.data.data.filter((prod) => prod.is_product);
      
      // Filter by assessment_type if provided (frontend filtering as fallback)
      if (assessmentType) {
        filteredProducts = filteredProducts.filter((prod) => {
          // Default to "PCF" if assessment_type is null/undefined (backward compatibility)
          const prodAssessmentType = prod.assessment_type || "PCF";
          return prodAssessmentType === assessmentType;
        });
      }
      
      setProducts(filteredProducts);
      setShared(response.data.shared);
      setWriteAccess(response.data.read_or_write);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteProduct = ({ id, business }) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/product/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business_id: business,
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const getProductDetail = ({
  id,
  business,
  setName = function () {
    return;
  },
  setCreatedAt = function () {
    return;
  },
  setSoldToCustomer = function () {
    return;
  },
  setProductNum = function () {
    return;
  },
  setLeasedToCustomer = function () {
    return;
  },
  setTakeBackCustomer = function () {
    return;
  },
  setTotalProductsSold = function () {
    return;
  },
  setSoldUnit = function () {
    return;
  },
  setTotalProductsLeased = function () {
    return;
  },
  setTotalProductsTakeback = function () {
    return;
  },
  setLeasedUnit = function () {
    return;
  },
  setSalesShare = function () {
    return;
  },
  setIndividualProduct = function () {
    return;
  },
  setIndividualProductPackaging = function () {
    return;
  },
  setFinalWeight = function () {
    return;
  },
  setVariationCategories = function () {
    return;
  },
  setCertificates = function () {
    return;
  },
  setCountryOrigin = function () {
    return;
  },
  setFunctionalUnit = function () {
    return;
  },
  setFunctionalUnitNum = function () {
    return;
  },
  setCountryCode = function () {
    return;
  },
  setLifetimeFunctional = function () {
    return;
  },
  setLifetimeFunctionalUnit = function () {
    return;
  },
  setFunctionalUnitDesc = function () {
    return;
  },
  setObjects = function () {
    return;
  },
  setWasteWeight = function () {
    return;
  },
  setTotalWeight = function () {
    return;
  },
  setWasteWeighIn = function () {
    return;
  },
  setTotalWeighIn = function () {
    return;
  },
  setFunctionalUnitUnit = function () {
    return;
  },
  setCcsClassification = function () {
    return;
  },
  setGtinEan = function () {
    return;
  },
  setBastaNumber = function () {
    return;
  },
  setOtherIds = function () {
    return;
  },
  setCreatedModified = function () {
    return;
  },
  setAssessmentType = function () {
    return;
  },
  setEpdApproval = function () {
    return;
  },
  setLcaLockStatus = function () {
    return;
  },
  setSector = function () {
    return;
  },
  setDppData = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + id + "/detail",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business_id: business,
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data.product);
      setName(response.data.data.product.name);
      setCreatedAt(response.data.data.product.created_at);
      setSoldToCustomer(response.data.data.product.sold_to_customer);
      setProductNum(response.data.data.product.product_num);
      setLeasedToCustomer(response.data.data.product.leased_to_customer);
      setTakeBackCustomer(response.data.data.product.take_back_customer);
      setTotalProductsSold(response.data.data.product.total_products_sold);
      setSoldUnit(response.data.data.product.sold_unit);
      setTotalProductsLeased(response.data.data.product.total_products_leased);
      setTotalProductsTakeback(
        response.data.data.product.total_products_takeback
      );
      setLeasedUnit(response.data.data.product.leased_unit);
      setSalesShare(response.data.data.product.sales_share);
      setIndividualProduct(response.data.data.product.individual_weight);
      setIndividualProductPackaging(
        response.data.data.product.individual_weight_packaging
      );
      setFinalWeight(response.data.data.product.your_weigh_in);
      setVariationCategories(response.data.data.product.variation_categories);
      setCertificates(response.data.data.product.certificates);
      setCountryOrigin(response.data.data.product.country_origin);
      setFunctionalUnit(response.data.data.product.functional_unit);
      setFunctionalUnitNum(response.data.data.product.functional_unit_num);
      setLifetimeFunctional(response.data.data.product.lifetime_functional);
      setLifetimeFunctionalUnit(
        response.data.data.product.lifetime_functional_unit
      );
      setFunctionalUnitDesc(response.data.data.product.functional_unit_desc);
      setWasteWeight(response.data.data.product.waste_weight);
      setTotalWeight(response.data.data.product.total_weight);
      setWasteWeighIn(response.data.data.product.waste_weigh_in);
      setTotalWeighIn(response.data.data.product.total_weigh_in);
      setFunctionalUnitUnit(response.data.data.product.functional_unit_unit);
      setCcsClassification(response.data.data.product.ccs_classification);
      setGtinEan(response.data.data.product.gtin_ean);
      setBastaNumber(response.data.data.product.basta_number);
      setOtherIds(response.data.data.product.other_ids);
      setCreatedModified(response.data.data.product.created_modified);
      setAssessmentType(response.data.data.product.assessment_type || "LCA");
      if (response.data.data.epd_approval != null) {
        setEpdApproval(response.data.data.epd_approval);
      }
      if (response.data.data.product?.lca_lock_status != null) {
        setLcaLockStatus(response.data.data.product.lca_lock_status);
      }
      if (response.data.data.product?.sector != null) {
        setSector(response.data.data.product.sector);
      }
      const product = response.data.data.product;
      if (product) {
        if (product.lca_lock_status === "epd_locked") {
          setDppData({
            dpp_uid: product.dpp_uid ?? null,
            dpp_url: product.dpp_url ?? null,
            dpp_is_published: !!product.dpp_is_published,
            dpp_published_at: product.dpp_published_at ?? null,
            dpp_registry_status: product.dpp_registry_status ?? "not_registered",
            dpp_registry_id: product.dpp_registry_id ?? null,
            opencirc_passport_id: product.opencirc_passport_id ?? null,
          });
        } else {
          setDppData(null);
        }
      }
    })

    .catch(function (error) {
      console.log(error);
    });
};

export const createProduct = ({
  name,
  year,
  subgroupId,
  business,
  variationCategories,
  productNum,
  sector,
  functional_unit_num,
  functional_unit_unit,
  functional_unit_desc,
  assessment_type = "PCF", // Default to PCF if not specified
  setStatus = function () {
    return;
  },
  setErrorMessage = function () {
    return;
  },
  setIdBusiness = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: name,
    product_num: productNum,
    variation_categories: variationCategories,
    is_product: true,
    components: [],
    year: year,
    subgroup: subgroupId,
    business_id: business,
    ...(sector != null && sector !== "" && { sector }),
    ...(functional_unit_num != null && functional_unit_num !== "" && { functional_unit_num }),
    ...(functional_unit_unit != null && functional_unit_unit !== "" && { functional_unit_unit }),
    ...(functional_unit_desc != null && functional_unit_desc !== "" && { functional_unit_desc }),
    assessment_type: assessment_type, // Include assessment_type in API request
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/product/add",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      // setSaving(false)
      setStatus(true);
      setIdBusiness(response.data.data.productID);

      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      // Swal.fire(
      //   "Error!",
      //   error,
      //   "error"
      // );
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      // setSaving(false)
    });
};

export const updateProduct = ({
  id,
  name,
  business,
  soldToCustomer,
  productNum,
  unit,
  leasedToCustomer,
  takeBackCustomer,
  totalProductsSold,
  soldUnit,
  totalProductsLeased,
  leasedUnit,
  salesShare,
  salesQty,
  salesUnit,
  individualProduct,
  individualProductPackaging,
  finalWeight,
  variationCategories,
  certificates,
  countryOrigin,
  functionalUnitNum,
  functionalUnit,
  countryCode,
  totalProductsTakeback,
  lifetimeFunctional,
  lifetimeFunctionalUnit,
  functionalUnitDesc,
  wasteWeight,
  totalWeight,
  wasteWeighIn,
  totalWeighIn,
  functionalUnitUnit,
  ccsClassification,
  gtinEan,
  bastaNumber,
  otherIds,
  createdModified,
  setErrorMessage = function () {
    return;
  },
  callback,
}) => {
  // Build payload object - only include fields that are explicitly provided (not undefined)
  // This allows partial updates without sending null values for unchanged fields
  const payload = {
    components: [], // Always include components array
  };

  // Only add fields to payload if they are not undefined
  if (name !== undefined) payload.name = name;
  if (productNum !== undefined) payload.product_num = productNum;
  if (soldToCustomer !== undefined) payload.sold_to_customer = soldToCustomer;
  if (leasedToCustomer !== undefined) payload.leased_to_customer = leasedToCustomer;
  if (takeBackCustomer !== undefined) payload.take_back_customer = takeBackCustomer;
  if (totalProductsSold !== undefined) payload.total_products_sold = totalProductsSold;
  if (soldUnit !== undefined) payload.sold_unit = soldUnit;
  if (totalProductsLeased !== undefined) payload.total_products_leased = totalProductsLeased;
  if (totalProductsTakeback !== undefined) payload.total_products_takeback = totalProductsTakeback;
  if (leasedUnit !== undefined) payload.leased_unit = leasedUnit;
  if (salesShare !== undefined) payload.sales_share = salesShare;
  if (salesQty !== undefined) payload.sales_qty = salesQty;
  if (salesUnit !== undefined) payload.sales_unit = salesUnit;
  if (individualProduct !== undefined) payload.individual_weight = individualProduct;
  if (individualProductPackaging !== undefined) payload.individual_weight_packaging = individualProductPackaging;
  if (finalWeight !== undefined) payload.your_weigh_in = finalWeight;
  if (variationCategories !== undefined) payload.variation_categories = variationCategories;
  if (certificates !== undefined) payload.certificates = certificates;
  if (countryOrigin !== undefined) payload.country_origin = countryOrigin;
  if (functionalUnitNum !== undefined) payload.functional_unit_num = functionalUnitNum;
  if (functionalUnit !== undefined) payload.functional_unit = functionalUnit;
  if (countryCode !== undefined) payload.country_code = countryCode;
  if (lifetimeFunctional !== undefined) payload.lifetime_functional = lifetimeFunctional;
  if (lifetimeFunctionalUnit !== undefined) payload.lifetime_functional_unit = lifetimeFunctionalUnit;
  if (functionalUnitDesc !== undefined) payload.functional_unit_desc = functionalUnitDesc;
  if (wasteWeight !== undefined) payload.waste_weight = wasteWeight;
  if (totalWeight !== undefined) payload.total_weight = totalWeight;
  if (wasteWeighIn !== undefined) payload.waste_weigh_in = wasteWeighIn;
  if (totalWeighIn !== undefined) payload.total_weigh_in = totalWeighIn;
  if (functionalUnitUnit !== undefined) payload.functional_unit_unit = functionalUnitUnit;
  if (ccsClassification !== undefined) payload.ccs_classification = ccsClassification;
  if (gtinEan !== undefined) payload.gtin_ean = gtinEan;
  if (bastaNumber !== undefined) payload.basta_number = bastaNumber;
  if (otherIds !== undefined) payload.other_ids = otherIds;
  if (createdModified !== undefined) payload.created_modified = createdModified;

  var data = JSON.stringify(payload);

  var config = {
    method: "put",
    url: baseUrl + "/api/business/product/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business_id: business,
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        confirmButtonColor: "#a9c1b4",
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();
      if (callback) callback();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        color: "#476355",
        background: "#f1f8ef",
      });
      console.log(error);
    });
};

export const addProductYearTab = ({ yearData }) => {
  const config = {
    method: "post",
    url: baseUrl + "/api/business/product/add-year-tab",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: {
      year: yearData,
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .catch(function (error) {
      console.log(error);
    });

  // return ;
};

export const getProductYearTabList = ({ setYearTabList }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product/year-tab",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      const data = response.data.data.map((year) => {
        return year.year;
      });
      setYearTabList(data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSubgroupProductList = ({
  setSubgroups = function () {
    return;
  },
  setSharedSubgroups = function () {
    return;
  },
  yearData,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  var config = {
    method: "get",
    url: baseUrl + "/api/business/subgroup-product/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    params: {
      year: year ? year : yearData ? yearData : null,
    },
  };

  axios(config)
    .then(function (response) {
      setSubgroups(response.data.data);
      setSharedSubgroups(response.data.shared);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSubgroupProduct = ({
  id,
  callback,
  is_shared = false,
  shared_business = null,
  shared_admin_id = null,
}) => {
  var data = JSON.stringify({
    is_shared: is_shared,
    shared_business: shared_business,
    shared_admin_id: shared_admin_id,
  });
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/subgroup-product-delete/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const createSubgroupProduct = ({
  name,
  /** Optional subgroup variation schema: [{ name, values: [{ value }] }] */
  variation_categories,
  /** Explicit reporting year (falls back to ?year= in URL) */
  year: yearParam,
  is_shared = false,
  shared_business = null,
  shared_admin_id = null,
  setErrorMessage = function () {
    return;
  },
  setNewSubgroupId = function () {
    return;
  },
  callback,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const yearFromUrl = urlParams.get("year");
  const year = yearParam != null && yearParam !== "" ? yearParam : yearFromUrl;
  const payload = {
    name: name,
    year: year,
    is_shared: is_shared,
    shared_business: shared_business,
    shared_admin_id: shared_admin_id,
  };
  if (Array.isArray(variation_categories) && variation_categories.length > 0) {
    payload.variation_categories = variation_categories;
  }
  var data = JSON.stringify(payload);

  var config = {
    method: "post",
    url: baseUrl + "/api/business/subgroup-product/add",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      setNewSubgroupId(response.data);
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();

      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      // Swal.fire(
      //   "Error!",
      //   error,
      //   "error"
      // );
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      // setSaving(false)
    });
};

export const updateSubgroupProduct = ({
  id,
  name,
  shared_business = null,
  is_shared = false,
  setErrorMessage = function () {
    return;
  },
  callback,
}) => {
  var data = JSON.stringify({
    name: name,
    shared_business: shared_business,
    is_shared: is_shared,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/subgroup-product-update/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      // Swal.fire({
      //   title: "Success!",
      //   icon: "success",
      //   confirmButtonColor: "#a9c1b4",
      //   color: "#476355",
      //   background: "#f1f8ef",
      // });
      setErrorMessage();
      if (callback) callback();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: "error",
      //   text: defaultAddErrorMessage,
      //   confirmButtonColor: "#a9c1b4",
      //   color: "#476355",
      //   background: "#f1f8ef",
      // });
      console.log(error);
    });
};
